import { render, staticRenderFns } from "./KernelOrders.vue?vue&type=template&id=7749e383&"
import script from "./KernelOrders.vue?vue&type=script&lang=js&"
export * from "./KernelOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports